import React from 'react';

import {Loading} from 'Components/Partials';

import AdminLayout from 'Pages/Admin/AdminLayout';

import StatsApi from 'Services/Api/Admin/Stats';
import {Toast} from 'Services';

export default class StatsIndex extends React.Component {
    /**
     * @var state
     * @type {{stats: null, working: boolean}}
     */
    state = {
        working: false,
        stats: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.fetchStats();
    };

    /**
     * @method fetchStats
     * @return {Promise<void>}
     */
    fetchStats = async () => {
        this.setState({working: true});

        const request = await StatsApi.get(null);

        if (request.success) {
            return this.setState({
                stats: request.data.data,
                working: false
            });
        }

        Toast.error();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, stats} = this.state;

        return (
            <AdminLayout title="Site Stats">
                <div className="p-2 flex justify-center items-center">
                    <button onClick={this.fetchStats} className="text-teal-500 hover:underline">
                        Refresh
                    </button>
                </div>

                <div className="p-6">
                    {working && (
                        <Loading />
                    )}

                    {!working && stats &&
                        <p className="mb-2 font-bold text-center">
                            Please note that actions by admin users are ignored when calculating these statistics.
                        </p>
                    }

                    {!working && stats && Object.entries(stats).map((stats2, i) => {
                        return (
                            <div className="mb-8" key={i}>
                                <p className="text-xl font-bold mb-2">
                                    {stats2[0]}
                                </p>

                                <div className="grid grid-cols-4 gap-4">
                                    {stats2[1].map((stat, j) => (
                                        <div className="bg-gray-200 flex flex-col justify-between items-center text-center px-4 py-8" key={j}>
                                            <span className="mb-4 text-xl">{stat.key}</span><br />
                                            <span className="text-3xl text-light">{stat.value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </AdminLayout>
        );
    }
}